module.exports = __webpack_public_path__ + "static/img/subscription-default.0b0bc2e9.jpg";